import React from 'react'
import { Button } from 'rsuite'
import { CloudOfflineOutline } from 'react-ionicons'

import './AppConnectionError.scss'

export interface AppConnectionErrorProps {
  onRetry?: () => void
}

export default function AppConnectionError ({ onRetry }: AppConnectionErrorProps) {
  const handleRetry = () => {
    if (onRetry) {
      onRetry()
    }
    else {
      window.location.reload()
    }
  }

  return (
    <div className="AppConnectionError">
      <div className="AppConnectionError__background" aria-hidden="true"></div>
      <div className="AppConnectionError__glow AppConnectionError__glow--one" aria-hidden="true"></div>
      <div className="AppConnectionError__glow AppConnectionError__glow--two" aria-hidden="true"></div>

      <div className="AppConnectionError__content" role="alert">
        <div className="AppConnectionError__card">
          <div className="AppConnectionError__icon" aria-hidden="true">
            <CloudOfflineOutline
              color="#ffffff"
              height="42px"
              width="42px"
            />
          </div>

          <h1 className="AppConnectionError__title">Потеряно соединение</h1>
          <p className="AppConnectionError__subtitle">
            Не удаётся получить данные от сервера. Проверьте подключение к интернету или попробуйте обновить страницу чуть позже.
          </p>

          <div className="AppConnectionError__actions">
            <Button
              appearance="primary"
              size="lg"
              className="AppConnectionError__button"
              onClick={handleRetry}
            >
              Повторить попытку
            </Button>
          </div>

          <div className="AppConnectionError__note">
            Если проблема остаётся, напишите нам и приложите скриншот ошибки. Команда поддержки уже в пути.
          </div>
        </div>
      </div>
    </div>
  )
}
